import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { PlessSharedModule } from '../../../shared/pless-shared.module';
import { AppCommonsModule } from '../../../commons/app-commons.module';
import { KYMW9004Component } from './kymw9004.component';
import { WjGridModule } from '@grapecity/wijmo.angular2.grid';
import { GetAuthoritySetDetailService } from './api-services/get-authority-set-detail.service';
import { GetFunctionListService } from './api-services/get-function-list.service';
import { RegistAuthoritySetService } from './api-services/regist-authority-set.service';
import { UpdateAuthoritySetService } from './api-services/update-authority-set.service';

/**
 * 権限一覧画面 モジュール設定クラス
 *
 * @export KYMW9003Module
 * @class KYMW9003Module
 */
@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    PlessSharedModule,
    AppCommonsModule,
    WjGridModule,
  ],
  declarations: [
    KYMW9004Component,
  ],
  providers: [
    GetAuthoritySetDetailService,
    GetFunctionListService,
    RegistAuthoritySetService,
    UpdateAuthoritySetService,
  ],
})
export class KYMW9004Module {

}